import axios, { AxiosHeaders } from "axios";
import api from "./api";
import { serviceMain } from "./serviceMain";

export type RegisterUser = {
  FirstName: string;
  LastName: string;
  SignInName: string;
  Email: string;
  Password: string;
  MobilePhone: string;
  NationalIdNumber: string;
  StoreCode?: string;
  GroupId?: string;
  OverrideIdCreatorPlatformType: number;
}

export type RegisterResult =
  | { status: 'OK' }
  | { status: 'CARD_RANGE_EXHAUSTED' }   // HTTP 416
  | { status: 'CARD_RANGE_NOT_FOUND' }   // HTTP 404
  | { status: 'KO' };

export async function registerUser(request: RegisterUser): Promise<RegisterResult> {
  const headers = new AxiosHeaders();
  headers.set('Content-Type', 'application/json');
  headers.set('Access-Control-Allow-Origin', '*');
  headers.set('Accept', 'application/json');

  try {
    const response = await api.post(
      '/v3/account/registerUserAndCustomer',
      JSON.stringify(request),
      { headers }
    );
    return response.status === 200 ? { status: 'OK' } : { status: 'KO' };
  } catch (error) {
    console.log("registerUser error:", axios.isAxiosError(error), (error as any)?.response?.status, error);
    if (axios.isAxiosError(error)) {
      switch (error.response?.status) {
        case 416: return { status: 'CARD_RANGE_EXHAUSTED' };
        case 404: return { status: 'CARD_RANGE_NOT_FOUND' };
      }
    }
    return { status: 'KO' };
  }
}